import GoogleMap from 'google-map-react';
import React from 'react';

export const GeoMap: any = (props: any) => {
  const {
    position,
    handleApiLoaded,
    center,
    zoom = 12,
  } = props;
  return (
    <div className="google-map-container">
      <GoogleMap
        center={center || position}
        defaultZoom={zoom}
        bootstrapURLKeys={{
          key: window.tz_globalConfigs.googleMapsApiKey,
          libraries: ['drawing'],
        }}
        onGoogleApiLoaded={handleApiLoaded}
      />
    </div>
  );
};
